"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { CheckCircle2, LogIn, WifiOff, X } from "lucide-react";
import { useAuthPromptStore, useToastStore } from "@/store/useAppStore";

export function AppStatus() {
  const [offline, setOffline] = useState(false);
  const message = useToastStore((state) => state.message);
  const clearToast = useToastStore((state) => state.clearToast);
  const returnTo = useAuthPromptStore((state) => state.returnTo);
  const authMessage = useAuthPromptStore((state) => state.message);
  const closeAuthPrompt = useAuthPromptStore((state) => state.closeAuthPrompt);
  useEffect(() => {
    const update = () => setOffline(!navigator.onLine);
    update(); window.addEventListener("online", update); window.addEventListener("offline", update);
    return () => { window.removeEventListener("online", update); window.removeEventListener("offline", update); };
  }, []);
  useEffect(() => { if (!message) return; const timer = window.setTimeout(clearToast, 3200); return () => window.clearTimeout(timer); }, [message, clearToast]);
  return <>
    {offline && <div className="offline-banner" role="status"><WifiOff/> 인터넷 연결이 끊겼어요. 저장된 정보만 볼 수 있습니다.</div>}
    {message && <div className="toast" role="status" aria-live="polite"><CheckCircle2/><span>{message}</span><button type="button" onClick={clearToast} aria-label="알림 닫기"><X/></button></div>}
    {returnTo && <div className="auth-prompt-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) closeAuthPrompt(); }}>
      <section className="auth-prompt" role="dialog" aria-modal="true" aria-labelledby="auth-prompt-title">
        <button className="auth-prompt-close" type="button" onClick={closeAuthPrompt} aria-label="로그인 안내 닫기"><X/></button>
        <span className="auth-prompt-icon"><LogIn/></span><h2 id="auth-prompt-title">로그인하시겠습니까?</h2><p>{authMessage}</p>
        <div><button type="button" onClick={closeAuthPrompt}>계속 둘러보기</button><Link href={`/auth?next=${encodeURIComponent(returnTo)}`} onClick={closeAuthPrompt}>로그인하기</Link></div>
      </section>
    </div>}
  </>;
}
